/**
 * @file Persist 4x6 vs receipt print format in localStorage + events.
 */

export const PRINT_FORMAT_STORAGE_KEY = 'equipbid.printFormat';
export const PRINT_FORMAT_4X6 = '4x6';
export const PRINT_FORMAT_RECEIPT = 'receipt';

export const PRINT_FORMAT_LABELS = {
  [PRINT_FORMAT_4X6]: 'Print 4x6',
  [PRINT_FORMAT_RECEIPT]: 'Print 3-1/8" Receipt',
};

export function getStoredPrintFormat() {
  try {
    const value = localStorage.getItem(PRINT_FORMAT_STORAGE_KEY);
    if (value === PRINT_FORMAT_RECEIPT || value === PRINT_FORMAT_4X6) {
      return value;
    }
  } catch {
    // ignore
  }
  return PRINT_FORMAT_4X6;
}

export function setStoredPrintFormat(format) {
  const next =
    format === PRINT_FORMAT_RECEIPT ? PRINT_FORMAT_RECEIPT : PRINT_FORMAT_4X6;
  try {
    localStorage.setItem(PRINT_FORMAT_STORAGE_KEY, next);
  } catch {
    // ignore
  }
  window.dispatchEvent(
    new CustomEvent('print-format-changed', { detail: { format: next } })
  );
  return next;
}
